import React, { FC, useEffect, useState } from 'react'

// Components
import { ComponentCardSlider } from '../../../models/components/cardSlider'

// Styles
import Slider from 'react-slick'
import { CardSliderOuter, CardSliderWrapper } from './style'
import { ContentCardSlider } from './subcomponents/contentCardSlider'
import { ImageCardSlider } from './subcomponents/imageCardSlider'

type Props = {
  data: ComponentCardSlider
}

const CardSlider: FC<Props> = ({ data }) => {
  const cardSliderData = {
    name: data?.name || '',
    eyebrow: data?.eyebrow || '',
    anchorLink: data?.anchorLink || '',
    theme: data?.theme || '',
    cards: data?.cards || '',
    topPadding: data?.topPadding || 'None',
    bottomPadding: data?.bottomPadding || 'None',
  }

  let cardsArray = cardSliderData.cards
  let sliderRef = React.useRef<Slider>(null)
  const [imageCardNav, setImageCardNav] = useState()
  const [totalSlide, setTotalSlide] = useState(0)
  const [currentIndex, setCurrentIndex] = useState(1)

  useEffect(() => {
    setTotalSlide(cardSliderData.cards.length)
  }, [])

  return (
    <>
      {cardSliderData.anchorLink?.identifier && (
        <span id={cardSliderData.anchorLink?.identifier}></span>
      )}
      <CardSliderOuter
        $topPadding={cardSliderData.topPadding}
        $bottomPadding={cardSliderData.bottomPadding}
        $bgTheme={cardSliderData.theme}
        data-cy="cardSlider">
        <CardSliderWrapper className="CardSlider__Wrapper">
          <div className="CardSlider__Content">
            <ContentCardSlider
              cardData={cardsArray}
              setImageCardNav={setImageCardNav}
              mainEyebrow={cardSliderData.eyebrow}></ContentCardSlider>
          </div>

          <div className="CardSlider__Image">
            <ImageCardSlider
              cardData={cardsArray}
              sliderRef={sliderRef}
              imageCardNav={imageCardNav}
              setCurrentIndex={setCurrentIndex}
              currentIndex={currentIndex}
              totalSlide={totalSlide}></ImageCardSlider>
          </div>
        </CardSliderWrapper>
      </CardSliderOuter>
    </>
  )
}
export default CardSlider
